import { z } from 'zod';

const MerchantIdSchema = z
  .string({
    required_error: 'merchantId is required'
  })
  .refine((value: string) => {
    return /^EP\d{5}/.test(value);
  }, `Not a valid MerchantId. Please use the format 'EP00001'`);

/**
 * MerchantId should be in the format of
 * @pattern EP followed by 5 numbers
 * @example EP00001
 */
type MerchantId = ReturnType<typeof MerchantIdSchema.parse>;

export { MerchantIdSchema, type MerchantId };
